import Axios, { AxiosInstance } from 'axios';

const defaultAxiosInstance: AxiosInstance = Axios.create();

const basicConfigureNewInstance = () => Axios.create();

export default defaultAxiosInstance;
export const axiosInstance = basicConfigureNewInstance();
